module.exports = __webpack_public_path__ + "img/ethereum.2a4bdfd7.png";